export default __webpack_public_path__ + "static/media/bumper_3.50bdeb6e.jpg";